import { useState, useEffect, useRef } from 'react'
import {
  useMediaQuery,
  TextField,
  InputAdornment,
  Grid,
  Container,
  Paper,
  useTheme,
  makeStyles,
  Link as MuiLink,
  Dialog,
  IconButton,
} from '@material-ui/core'
import TextCollapseSp from '../ui/TextCollapseSp'
import DeMinimis from './DeMinimis'
import RestrictedProducts from './RestrictedProducts'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import { Autocomplete } from '@material-ui/lab'
import * as Scroll from 'react-scroll'
import Layout from '../common/Layout'
import ButtonSp from '../ui/ButtonSp'
import clsx from 'clsx'
import { useForm } from 'react-hook-form'
import Axios from 'axios'
import SuccessModal from '../common/SuccessModal'
import getFaqInter from './faqInter'
import getFaqLocal from './faqLocal'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import ReCAPTCHA from 'react-google-recaptcha'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

const offsetMobile = -170
const offsetDesktop = -100

const useStyles = makeStyles((theme) => ({
  page: {
    ...theme.homeStyle.root,
  },
  searchBanner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    background: 'url("/static/img/faq/search_banner.jpg")',
    '& h1': {
      marginTop: 0,
      color: 'white',
      marginBottom: theme.spacing(2),
      fontWeight: 500,
      fontSize: 52,
      ...theme.headerFont,
      lineHeight: 1.3,
      [theme.breakpoints.only('sm')]: {
        fontSize: 40,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 32,
      },
    },
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      height: theme.homeStyle.heroImageHeightDesktop,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(2)}px 0 ${theme.spacing(
        2
      )}px`,
      backgroundPosition: 'top',
      height: theme.homeStyle.heroImageHeightMobile,
    },
  },
  faqSectionOuter: {
    width: '100%',
  },
  sendQuestionOuter: {
    width: '100%',
    color: 'white',
    background:
      'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),url("/static/img/faq/send-question.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: `${theme.spacing(8)}px 0`,
  },
  button: {
    ...theme.homeStyle.button,
  },
  sendQuestionInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    '& h2': {
      fontWeight: 400,
      fontSize: 40,
      margin: 0,
      ...theme.headerFont,
    },
    '& h3': {
      fontWeight: 400,
      fontSize: 20,
    },
  },
  tabPaper: {
    width: '90%',
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    cursor: 'pointer',
    '& h4': {
      margin: 0,
      fontWeight: 400,
      fontSize: 22,
    },
    '& h5': {
      margin: 0,
      fontWeight: 400,
      fontSize: 16,
      color: '#828282',
    },
  },
  tabPaperDense: {
    width: '90%',
    padding: theme.spacing(1),
    margin: theme.spacing(0),
    cursor: 'pointer',
    '& h4': {
      margin: 0,
      fontWeight: 400,
      fontSize: 16,
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      width: '100%',
    },
  },
  active: {
    color: theme.palette.primary.main,
  },
  faqMainGrid: {
    '& h3': {
      fontWeight: 400,
      fontSize: 32,
    },
    '& h4': {
      fontWeight: 400,
      fontSize: 20,
    },
    '& p': {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      padding: `0 ${theme.spacing(2)}px`,
    },
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(4),
    position: 'relative',
  },
  closeBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
    margin: theme.spacing(2),
  },
  modalTitle: {
    ...theme.homeStyle.title,
  },
  verticalSpacer2: {
    height: theme.spacing(2),
  },
  sideSticky: {
    position: 'sticky',
    top: 70,
    padding: `${theme.spacing(2)}px 0`,
  },
  faqSectionInner: {
    padding: `${theme.spacing(10)}px 0`,
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(2)}px 0`,
    },
  },
  tabPaperDenseActive: {
    backgroundColor: theme.palette.primary.main,
  },
  activeDense: {
    color: 'white',
  },
  categoryTitle: {
    ...theme.headerFont,
  },
  marginTop0OnTabletUp: {
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
}))

const TabPaper = ({ title, subtitle = '', classes, type = 'small' }) => {
  const [isActive, setActive] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  if (type === 'small')
    return (
      <Scroll.Link
        to={title}
        smooth="easeInOutQuart"
        duration={250}
        offset={isMobile ? offsetMobile : offsetDesktop}
        spy={true}
        onSetActive={() => setActive(true)}
        onSetInactive={() => setActive(false)}
      >
        <Paper
          className={clsx(
            classes.tabPaperDense,
            isActive && classes.tabPaperDenseActive
          )}
          elevation={0}
        >
          <h4 className={clsx(isActive && classes.activeDense)}>{title}</h4>
        </Paper>
      </Scroll.Link>
    )

  return (
    <Scroll.Link
      to={title}
      smooth="easeInOutQuart"
      duration={250}
      offset={isMobile ? offsetMobile : offsetDesktop}
      spy={true}
      onSetActive={() => setActive(true)}
      onSetInactive={() => setActive(false)}
    >
      <Paper className={classes.tabPaper} elevation={isActive ? 3 : 0}>
        <h4 className={clsx(isActive && classes.active)}>{title}</h4>
        <h5>{subtitle}</h5>
      </Paper>
    </Scroll.Link>
  )
}

const FaqPage = ({ type = 'local', title, keywords, description }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const classes = useStyles()

  const { t } = useTranslation('faq')
  const Router = useRouter()
  const language = Router.locale

  const [keyword, setKeyword] = useState(null) // This will always be null or valid question
  const [isModalOpen, setModalOpen] = useState(false)
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false)
  const [isErrorModalOpen, setErrorModalOpen] = useState(false)
  const [isFormExecuting, setFormExecuting] = useState(false)
  const { register, handleSubmit } = useForm()
  const recaptchaRef = useRef(null)

  const faqData =
    type === 'inter' ? getFaqInter(language) : getFaqLocal(language)

  const handleSearch = (dest) => {
    if (keyword === null) return
    Scroll.scroller.scrollTo(dest, {
      smooth: 'easeInOutQuart',
      offset: isMobile ? offsetMobile : offsetDesktop,
    })
  }

  const onFormSubmit = handleSubmit(async (data) => {
    try {
      setFormExecuting(true)
      const token = await recaptchaRef.current.executeAsync()
      const {
        data: { success: captchaSuccess },
      } = await Axios.post('/api/recaptcha/validate', { recaptchaToken: token })
      if (captchaSuccess) {
        const res = await Axios.post('/api/faq/submit-question', data)
        if (res.data.status === 'success') {
          setSuccessModalOpen(true)
        } else {
          setErrorModalOpen(true)
        }
      } else {
        setErrorModalOpen(true)
      }
    } catch (err) {
      setErrorModalOpen(true)
    } finally {
      setModalOpen(false)
      setFormExecuting(false)
    }
  })

  useEffect(() => {
    handleSearch(keyword)
  }, [keyword])

  // handle search from query
  useEffect(() => {
    if (!Router.isReady) return
    const key = Router.query.search
    if (key === 'cod') {
      setKeyword('ขั้นตอนการใช้บริการเก็บเงินปลายทาง')
    } else if (key === 'insurance') {
      setKeyword('การประกันหรือเคลมสินค้า เนื่องจากสินค้าเสียหาย')
    }
  }, [Router.isReady])

  const handleAutoCompleteInputChange = (e, newValue) => {
    setKeyword(newValue)
  }

  const autoCompleteOptions = () => {
    let result = []
    Object.entries(faqData).forEach(([category, cateData]) => {
      Object.keys(cateData).forEach((question) => {
        if (question !== 'subtitle') result.push(question)
      })
    })
    return result
  }

  const renderSearchBanner = () => (
    <div
      className={classes.searchBanner}
      style={isMobile ? { position: 'sticky', top: -205, zIndex: 999 } : null}
    >
      <h1>{t('what-kind-of-help')}</h1>
      <div
        style={{
          width: '100%',
          maxWidth: 500,
          position: isMobile ? 'sticky' : 'inherit',
          top: 100,
        }}
      >
        <Autocomplete
          fullWidth
          autoHighlight
          options={autoCompleteOptions()}
          value={keyword}
          onChange={handleAutoCompleteInputChange}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="normal"
              variant="outlined"
              fullWidth
              style={{ backgroundColor: 'white', borderRadius: 5 }}
              placeholder={t('type-the-word')}
              autoFocus
              InputProps={{
                ...params.InputProps,
                type: 'text',
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="disabled" />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </div>
    </div>
  )

  const renderQuestions = () => {
    let otherComponent = null

    return (
      <>
        {Object.entries(faqData).map(([category, cateData]) => {
          let collapseData = []
          Object.entries(cateData).forEach(([title, desc]) => {
            if (title !== 'subtitle' && desc !== 'De minimis' && desc !== 'Restricted products') {
              collapseData.push({
                title,
                desc,
              })
            }

            if (desc === 'De minimis') {
              otherComponent = <DeMinimis />
            }

            if (desc === 'Restricted products') {
              otherComponent = <RestrictedProducts />
            }
          })

          return (
            <>
              <Scroll.Element id={category} key={category}>
                <h3 className={classes.categoryTitle}>{category}</h3>
                {collapseData.length > 0 ? <TextCollapseSp data={collapseData} searchedTitle={keyword} /> : otherComponent}
              </Scroll.Element>
            </>
          )
        })}
      </>
    )
  }

  const renderFaqSection = () => (
    <div className={classes.faqSectionOuter}>
      <Container className={classes.faqSectionInner}>
        <Grid container>
          <Grid item xs={12} sm={3}>
            <div className={classes.sideSticky}>
              {Object.entries(faqData).map(([title, data]) => (
                <TabPaper
                  title={title}
                  subtitle={data.subtitle}
                  key={title}
                  classes={classes}
                  type='large'
                />
              ))}
            </div>
          </Grid>
          <Grid item xs={12} sm={9} className={classes.faqMainGrid}>
            {renderQuestions()}
          </Grid>
        </Grid>
      </Container>
    </div>
  )

  const renderSendQuestion = () => {
    return (
      <>
        <div className={classes.sendQuestionOuter}>
          <Container className={classes.sendQuestionInner}>
            <h2>{t('not-found-your-question')}</h2>
            <h3
              style={{
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(3),
              }}
            >
              {t('if-your-question-is-not-answered')}
            </h3>
            <ButtonSp
              className={classes.button}
              onClick={() => setModalOpen(true)}
            >
              {t('submit-your-problem')}
            </ButtonSp>
          </Container>
        </div>
        <Dialog
          open={isModalOpen}
          onClose={() => setModalOpen(false)}
          maxWidth="md"
          fullScreen={isMobile}
        >
          <form onSubmit={onFormSubmit} className={classes.modal}>
            <IconButton
              className={classes.closeBtn}
              onClick={() => setModalOpen(false)}
            >
              <CloseIcon />
            </IconButton>
            <h1 className={classes.modalTitle}>{t('submit-your-problem')}</h1>
            <Grid container spacing={isMobile ? 1 : 2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  label={t('name-surname')}
                  fullWidth
                  margin="normal"
                  inputRef={register}
                  name="nameSurname"
                  style={{ marginBottom: 0 }}
                  placeholder={t('name-surname-p')}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  label={t('phone')}
                  fullWidth
                  margin="normal"
                  inputRef={register}
                  name="phone"
                  style={{ marginBottom: 0 }}
                  placeholder={t('phone-p')}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t('problem-detail')}
                  fullWidth
                  multiline
                  rows={5}
                  margin="normal"
                  inputRef={register}
                  name="problemDetail"
                  className={classes.marginTop0OnTabletUp}
                  placeholder={t('problem-detail-p')}
                />
              </Grid>
            </Grid>
            <div className={classes.verticalSpacer2} />
            <ButtonSp
              className={classes.button}
              type="submit"
              loading={isFormExecuting}
            >
              {t('submit-button')}
            </ButtonSp>
            <ReCAPTCHA
              size="invisible"
              sitekey={publicRuntimeConfig.recaptcha2Key}
              ref={recaptchaRef}
              badge="bottomleft"
            />
          </form>
        </Dialog>
      </>
    )
  }

  return (
    <div>
      <Layout title={title} keywords={keywords} description={description}>
        <div className={classes.page}>
          {renderSearchBanner()}
          {renderFaqSection()}
          {renderSendQuestion()}
        </div>
        <SuccessModal
          isOpen={isSuccessModalOpen}
          setOpen={setSuccessModalOpen}
          title={t('success-modal-title')}
          subtitle={t('success-modal-subtitle')}
        />
        <SuccessModal
          isOpen={isErrorModalOpen}
          setOpen={setErrorModalOpen}
          title={t('error-modal-title')}
          subtitle={t('error-modal-subtitle')}
          type="error"
        />
      </Layout>
    </div>
  )
}

export default FaqPage
